/**
 * Custom JavaScript do tema (Focal). Ponto de extensão oficial.
 * Alterações Blackstone abaixo. Cada bloco é independente e reversível.
 */

/* ============================================================
 * BKST — Parcelamento na PDP (TODOS os produtos)
 * Exibe "ou 2x de R$ X sem juros" logo abaixo do preço.
 * Só age quando existe o container de preço da PDP.
 * ============================================================ */
(function () {
  function fmt(n) {
    return 'R$ ' + n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function parsePrice(t) {
    if (!t) return null;
    var s = t.replace(/[^0-9.,]/g, '');
    if (s.indexOf(',') > -1) { s = s.replace(/\./g, '').replace(',', '.'); }
    var v = parseFloat(s);
    return isNaN(v) ? null : v;
  }
  function render() {
    var cont = document.querySelector('.product__info .product-meta__price-list-container')
            || document.querySelector('.product-meta__price-list-container');
    if (!cont) return;
    var priceEl = cont.querySelector('.price--highlight') || cont.querySelector('.price--large') || cont.querySelector('.price');
    var val = parsePrice(priceEl && priceEl.textContent);
    if (!val) return;
    var el = cont.parentNode.querySelector('.bkst-parcelamento');
    if (!el) {
      el = document.createElement('div');
      el.className = 'bkst-parcelamento';
      el.style.cssText = 'margin-top:6px;font-size:14px;line-height:1.35;';
      cont.insertAdjacentElement('afterend', el);
    }
    el.innerHTML = 'ou <strong>2x de ' + fmt(val / 2) + '</strong> sem juros no cartão';
  }
  document.addEventListener('DOMContentLoaded', render);
  document.addEventListener('variant:changed', render);
  setTimeout(render, 600);
  setTimeout(render, 1500);
})();

/* ==============================================================
 * BKST — Frete REAL por CEP: página do produto, carrinho e mini-cart
 * Cota as MESMAS tarifas que aparecem no checkout (Frenet) usando
 * /cart/shipping_rates.json — mostra transportadora, valor e prazo.
 * Na PDP a variante escolhida entra no carrinho numa linha marcada
 * (_bkst_cotacao), é cotada e removida em seguida; qualquer linha
 * marcada que sobre é limpa no carregamento da página.
 * ============================================================== */
(function () {
  var STORAGE_KEY = 'bkst_cep';
  var TAG = '_bkst_cotacao';
  var PISO = 30000;            // R$ 300,00 em centavos — piso do frete grátis (Brasil todo, opção mais econômica, desde 07/10/2026)
  var MAX_LINHAS = 4;          // no máximo 4 opções na tela

  function brl(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function reaisParaCentavos(v) { var n = parseFloat(v); return isNaN(n) ? 0 : Math.round(n * 100); }
  function digits(v) { return String(v || '').replace(/\D/g, ''); }
  function maskCep(v) {
    var d = digits(v).slice(0, 8);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }
  function cepValido(cep) { return digits(cep).length === 8; }
  function isSudeste(cep) {
    var d = digits(cep);
    if (d.length !== 8) return null;
    var p = parseInt(d.slice(0, 2), 10);
    return p >= 1 && p <= 39;                       // 01–39 = SP/RJ/ES/MG
  }
  // A Shopify EXIGE a UF junto do CEP na cotação (sem ela devolve 422
  // {"province":["Selecione um estado"]}). Faixas oficiais dos Correios.
  var FAIXAS = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [78900, 78999, 'RO'], [79000, 79999, 'MS'],
    [80000, 87999, 'PR'], [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];
  function ufDoCep(cep) {
    var p = parseInt(digits(cep).slice(0, 5), 10);
    if (isNaN(p)) return null;
    for (var i = 0; i < FAIXAS.length; i++) {
      if (p >= FAIXAS[i][0] && p <= FAIXAS[i][1]) return FAIXAS[i][2];
    }
    return null;
  }
  function onCartPage() { return /(^|\/)cart(\/|$|\?|#)/.test(location.pathname); }

  function injectStyle() {
    if (document.getElementById('bkst-frete-style')) return;
    var s = document.createElement('style');
    s.id = 'bkst-frete-style';
    s.textContent = [
      '.bkst-frete{margin:16px 0;padding:14px 16px;border:1px solid rgba(128,128,128,.28);border-radius:10px;}',
      '.bkst-frete__label{display:block;font-size:13px;font-weight:600;letter-spacing:.02em;margin-bottom:8px;text-transform:uppercase;opacity:.85;}',
      '.bkst-frete__row{display:flex;gap:8px;flex-wrap:wrap;align-items:center;}',
      '.bkst-frete__cep{flex:1;min-width:140px;height:42px;padding:0 12px;border:1px solid rgba(128,128,128,.4);border-radius:8px;background:transparent;color:inherit;font-size:15px;}',
      '.bkst-frete__btn{height:42px;padding:0 18px;border:0;border-radius:8px;background:#111;color:#fff;font-weight:600;cursor:pointer;font-size:14px;}',
      '.bkst-frete__btn:hover{opacity:.9;}',
      '.bkst-frete__btn[disabled]{opacity:.55;cursor:default;}',
      '.bkst-frete__msg{margin-top:12px;padding:12px 14px;border-radius:8px;font-size:14px;line-height:1.4;display:none;}',
      '.bkst-frete__msg--ok{display:block;background:rgba(46,160,90,.14);border:1px solid rgba(46,160,90,.5);color:#1c7a44;}',
      '.bkst-frete__msg--no{display:block;background:rgba(128,128,128,.12);border:1px solid rgba(128,128,128,.35);}',
      '.bkst-frete__msg--err{display:block;background:rgba(200,70,50,.12);border:1px solid rgba(200,70,50,.45);color:#b24a32;}',
      '.bkst-frete__msg strong{font-weight:700;}',
      '.bkst-frete__list{list-style:none;margin:10px 0 0;padding:0;display:flex;flex-direction:column;gap:6px;}',
      '.bkst-frete__opt{display:flex;align-items:baseline;gap:8px;padding:8px 10px;border:1px solid rgba(128,128,128,.28);border-radius:8px;font-size:13.5px;}',
      '.bkst-frete__opt.is-free{border-color:rgba(46,160,90,.6);background:rgba(46,160,90,.10);}',
      '.bkst-frete__nm{flex:1;min-width:0;font-weight:700;}',
      '.bkst-frete__pz{font-size:12px;opacity:.75;font-weight:500;white-space:nowrap;}',
      '.bkst-frete__vl{font-weight:800;white-space:nowrap;}',
      '.bkst-frete__opt.is-free .bkst-frete__vl{color:#1c7a44;}',
      '.bkst-frete__bar{display:block;height:8px;border-radius:6px;background:rgba(128,128,128,.25);margin-top:10px;overflow:hidden;}',
      '.bkst-frete__bar-fill{display:block;height:100%;background:#2ea05a;border-radius:6px;transition:width .4s;}',
      '.bkst-frete__hint{margin-top:8px;font-size:12.5px;font-weight:600;opacity:.9;}',
      '@media (prefers-color-scheme: dark){.bkst-frete__btn{background:#e3ac48;color:#100e0a;}.bkst-frete__msg--ok{color:#6fb07c;}.bkst-frete__opt.is-free .bkst-frete__vl{color:#7dffa8;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function cartJson() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }
  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  // Remove qualquer linha de cotação que tenha sobrado (aba fechada no meio, rede caiu...).
  function limparCotacao() {
    return cartJson().then(function (c) {
      var updates = {}, achou = false;
      c.items.forEach(function (it) {
        if (it.properties && it.properties[TAG]) { updates[it.key] = 0; achou = true; }
      });
      if (!achou) return c;
      return jsonPost('/cart/update.js', { updates: updates });
    });
  }

  function buscarTaxas(cep) {
    var uf = ufDoCep(cep);
    if (!uf) return Promise.reject(new Error('cep-fora-de-faixa'));
    var url = '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + encodeURIComponent(digits(cep)) +
              '&shipping_address%5Bcountry%5D=Brazil&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf);
    return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('rates ' + r.status);
      return r.json();
    }).then(function (j) { return (j && j.shipping_rates) || []; });
  }

  // variantId != null  -> PDP: adiciona a linha marcada, cota e remove.
  // variantId == null  -> carrinho/mini-cart: cota o carrinho como está.
  function cotar(cep, variantId) {
    if (!variantId) {
      return cartJson().then(function (c) {
        return buscarTaxas(cep).then(function (rates) { return { rates: rates, total: c.total_price }; });
      });
    }
    var props = {}; props[TAG] = '1';
    return jsonPost('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: props }] })
      .then(cartJson)
      .then(function (c) {
        var total = c.total_price;
        return buscarTaxas(cep).then(function (rates) {
          return limparCotacao().then(function () { return { rates: rates, total: total }; });
        });
      })
      .catch(function (err) {
        return limparCotacao().then(function () { throw err; }, function () { throw err; });
      });
  }

  function prazoTexto(rate) {
    var d = rate.delivery_days;
    if (!d || !d.length) return '';
    var a = d[0], b = d[d.length - 1];
    if (!a && a !== 0) return '';
    return (a === b) ? (a + (a === 1 ? ' dia útil' : ' dias úteis')) : ('de ' + a + ' a ' + b + ' dias úteis');
  }

  // Nós de texto, nunca innerHTML: os nomes vêm da transportadora.
  function desenharOpcoes(rates) {
    var ul = document.createElement('ul');
    ul.className = 'bkst-frete__list';
    rates.slice(0, MAX_LINHAS).forEach(function (r) {
      var cents = reaisParaCentavos(r.price);
      var li = document.createElement('li');
      li.className = 'bkst-frete__opt' + (cents === 0 ? ' is-free' : '');
      var nm = document.createElement('span'); nm.className = 'bkst-frete__nm';
      nm.textContent = String(r.presentment_name || r.name || 'Envio');
      var pz = document.createElement('span'); pz.className = 'bkst-frete__pz'; pz.textContent = prazoTexto(r);
      var vl = document.createElement('span'); vl.className = 'bkst-frete__vl';
      vl.textContent = cents === 0 ? 'GRÁTIS' : brl(cents);
      li.appendChild(nm); li.appendChild(pz); li.appendChild(vl);
      ul.appendChild(li);
    });
    return ul;
  }

  function mostrarResultado(box, cep, variantId) {
    var msg = box.querySelector('.bkst-frete__msg');
    var btn = box.querySelector('.bkst-frete__btn');
    msg.className = 'bkst-frete__msg';
    if (!cepValido(cep)) {
      msg.classList.add('bkst-frete__msg--err');
      msg.textContent = 'Digite um CEP válido (8 dígitos).';
      return;
    }
    if (!ufDoCep(cep)) {
      msg.classList.add('bkst-frete__msg--err');
      msg.textContent = 'Não reconheci esse CEP. Confira os números.';
      return;
    }
    try { localStorage.setItem(STORAGE_KEY, cep); } catch (e) {}
    btn.disabled = true; btn.textContent = 'Calculando...';
    msg.className = 'bkst-frete__msg bkst-frete__msg--no';
    msg.textContent = 'Consultando as transportadoras...';

    cotar(cep, variantId).then(function (res) {
      btn.disabled = false; btn.textContent = 'Ver frete';
      var rates = res.rates.slice().sort(function (a, b) { return reaisParaCentavos(a.price) - reaisParaCentavos(b.price); });
      msg.textContent = '';
      msg.className = 'bkst-frete__msg bkst-frete__msg--no';
      if (!rates.length) {
        msg.classList.remove('bkst-frete__msg--no');
        msg.classList.add('bkst-frete__msg--err');
        msg.textContent = 'Não encontramos entrega para esse CEP. Fale com a gente que a gente resolve.';
        return;
      }
      var maisBarato = reaisParaCentavos(rates[0].price);
      var cab = document.createElement('div');
      if (maisBarato === 0) {
        msg.className = 'bkst-frete__msg bkst-frete__msg--ok';
        cab.textContent = 'Frete GRÁTIS para o seu CEP.';
        cab.style.fontWeight = '700';
        var nota = document.createElement('div');
        nota.className = 'bkst-frete__hint';
        nota.textContent = 'O frete grátis é na opção mais econômica (Optimus). As demais opções, como Sedex, são cobradas.';
        cab.appendChild(nota);
      } else {
        cab.textContent = 'Entregas disponíveis para ' + maskCep(cep) + ':';
        cab.style.fontWeight = '600';
      }
      msg.appendChild(cab);
      msg.appendChild(desenharOpcoes(rates));

      // Barra de progresso para o frete grátis (Brasil todo desde 07/10/2026).
      if (maisBarato > 0 && res.total < PISO) {
        var falta = PISO - res.total;
        var hint = document.createElement('div');
        hint.className = 'bkst-frete__hint';
        hint.textContent = 'Faltam ' + brl(falta) + ' para o frete grátis.';
        msg.appendChild(hint);
        var bar = document.createElement('span'); bar.className = 'bkst-frete__bar';
        var fill = document.createElement('span'); fill.className = 'bkst-frete__bar-fill';
        fill.style.width = Math.max(4, Math.min(100, Math.round(res.total * 100 / PISO))) + '%';
        bar.appendChild(fill); msg.appendChild(bar);
      }
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'Ver frete';
      msg.className = 'bkst-frete__msg bkst-frete__msg--err';
      msg.textContent = 'Não consegui calcular agora. Tente de novo em instantes.';
    });
  }

  // getVariant: função que devolve a variante a cotar (PDP) ou null (carrinho).
  function createBox(getVariant, titulo) {
    injectStyle();
    var box = document.createElement('div');
    box.className = 'bkst-frete';

    var label = document.createElement('span');
    label.className = 'bkst-frete__label';
    label.textContent = titulo;

    var row = document.createElement('div'); row.className = 'bkst-frete__row';
    var input = document.createElement('input');
    input.type = 'text'; input.inputMode = 'numeric'; input.className = 'bkst-frete__cep';
    input.placeholder = '00000-000'; input.maxLength = 9; input.setAttribute('aria-label', 'CEP');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'bkst-frete__btn'; btn.textContent = 'Ver frete';
    row.appendChild(input); row.appendChild(btn);

    var msg = document.createElement('div');
    msg.className = 'bkst-frete__msg';
    msg.setAttribute('role', 'status'); msg.setAttribute('aria-live', 'polite');

    box.appendChild(label); box.appendChild(row); box.appendChild(msg);

    input.addEventListener('input', function () { input.value = maskCep(input.value); });
    function go() { mostrarResultado(box, input.value, getVariant()); }
    btn.addEventListener('click', go);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });

    // Se o cliente já informou o CEP antes, reaproveita — mas só preenche.
    // Não cota sozinho para não gastar chamada nem mexer no carrinho sem pedido.
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved) input.value = maskCep(saved);
    } catch (e) {}
    return box;
  }

  function variantAtual() {
    var i = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var v = i && parseInt(i.value, 10);
    return v || null;
  }

  function mountAll() {
    // 1) PÁGINA DO PRODUTO — logo abaixo dos botões de compra.
    var pf = document.querySelector('.product__info .product-form') || document.querySelector('.product-form');
    if (pf && !document.querySelector('.product__info .bkst-frete') && variantAtual()) {
      pf.insertAdjacentElement('afterend', createBox(variantAtual, 'Calcular frete e prazo'));
    }

    // 2) PÁGINA /cart
    if (onCartPage()) {
      var target = document.querySelector('.cart .cart__content')
                || document.querySelector('.cart__content')
                || document.querySelector('.cart');
      if (target && !target.querySelector('.bkst-frete')) {
        target.insertBefore(createBox(function () { return null; }, 'Calcular frete e prazo'), target.firstChild);
      }
    }

    // 3) MINI-CART
    var footer = document.querySelector('#mini-cart .mini-cart__drawer-footer');
    if (footer && !footer.querySelector('.bkst-frete')) {
      footer.insertBefore(createBox(function () { return null; }, 'Calcular frete e prazo'), footer.firstChild);
    }
  }

  document.addEventListener('DOMContentLoaded', function () { limparCotacao().catch(function () {}); mountAll(); });
  document.addEventListener('cart:updated', function () { setTimeout(mountAll, 60); });
  document.addEventListener('cart:refresh', function () { setTimeout(mountAll, 60); });
  setTimeout(mountAll, 500);
  setTimeout(mountAll, 1500);

  // O Focal re-renderiza o mini-carrinho ao adicionar/alterar itens: reinjeta.
  (function observe() {
    var mc = document.getElementById('mini-cart');
    if (!mc) { setTimeout(observe, 600); return; }
    new MutationObserver(function () { mountAll(); }).observe(mc, { childList: true, subtree: true });
    mountAll();
  })();
})();

/* ============================================================
 * BKST — Troca de café / sticker (módulo compartilhado)
 * Usado pelo kit na PDP (sections/bkst-kit.liquid) e pelo carrinho.
 * Lista = produtos EM ESTOQUE das coleções, ordenados por venda.
 * ============================================================ */
(function () {
  // Ordem de destaque (mais vendidos primeiro). Não listados entram depois.
  var ORDER = {
    cafe: ['cafe-especial-dark-operation', 'cafe-gourmet-independence-or-death', 'cafe-especial-victory-over-death', 'cafe-gourmet-grumec', 'cafe-especial-coffee-or-die'],
    sticker: ['sticker-violence-art', 'sticker-triade-opesp', 'sticker-comandos-2-0', 'sticker-bkst-company', 'sticker-victory-over-death', 'sticker-welcome-to-the-jungle', 'sticker-bjj-uae', 'sticker-death-before-dishonor', 'sticker-grumec', 'sticker-night-stalker-rj', 'sticker-chest-rig', 'sticker-pqd-skull', 'sticker-comandos-anfibios', 'sticker-born-to-be-wild', 'sticker-pqd', 'sticker-grumec-2-0', 'sticker-independence-or-death', 'sticker-rj-tactical', 'sticker-be-a-man', 'sticker-forcas-especiais']
  };
  var SRC = {
    cafe: '/collections/brazilian-coffee/products.json?limit=250',
    sticker: '/collections/stickers/products.json?limit=250',
    caneca: '/collections/canecas/products.json?limit=250',
    patch: '/collections/patches/products.json?limit=250'
  };
  var GENERIC = { cafe: 'Café Blackstone', sticker: 'Sticker Blackstone', caneca: 'Caneca Blackstone', patch: 'Patch Blackstone' };
  var LABEL = { cafe: 'Trocar café', sticker: 'Trocar sticker', caneca: 'Trocar caneca', patch: 'Trocar patch' };
  var cache = Object.create(null);

  function money(c) {
    return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  // "CAFÉ ESPECIAL - DARK OPERATION" -> "DARK OPERATION"; "ADESIVO VIOLENCE ART" -> "VIOLENCE ART"
  function shortName(title) {
    return String(title || '')
      .replace(/^CAF[ÉE]\s+(GOURMET|ESPECIAL)?\s*(250\s*GR)?\s*-?\s*/i, '')
      .replace(/^(ADESIVO|STICKER)\s+/i, '')
      .replace(/^PATCH\s+(BORDADO|EMBORRACHADO)?\s*-?\s*/i, '')
      .replace(/\s*-\s*VELCRO\s*$/i, '')
      .replace(/^BLACKSTONE\s+/i, '')
      .trim();
  }
  // Uma opção POR VARIANTE (café: Moído e Em Grãos separados), inclusive esgotadas.
  // Ordem: em estoque primeiro (por ranking de venda), esgotadas por último (apagadas).
  function fetchOptions(kind) {
    if (!Object.prototype.hasOwnProperty.call(SRC, kind)) return Promise.reject(new Error('tipo desconhecido'));
    if (cache[kind]) return Promise.resolve(cache[kind]);
    return fetch(SRC[kind], { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ord = ORDER[kind] || [];
        var list = [];
        (d.products || []).forEach(function (p) {
          if (kind === 'cafe' && !/^CAF/i.test(p.title)) return; // exclui drip, packs, kits
          var rank = ord.indexOf(p.handle); if (rank < 0) rank = 999;
          var img = (p.images && p.images[0] && p.images[0].src) || '';
          (p.variants || []).forEach(function (v, vi) {
            list.push({
              handle: p.handle, title: p.title, short: shortName(p.title),
              vid: v.id, price: Math.round(parseFloat(v.price) * 100),
              vtitle: (v.title === 'Default Title' ? '' : v.title),
              img: img, available: !!v.available, rank: rank, vindex: vi
            });
          });
        });
        list.sort(function (a, b) {
          if (a.available !== b.available) return a.available ? -1 : 1;
          if (a.rank !== b.rank) return a.rank - b.rank;
          return a.vindex - b.vindex;
        });
        cache[kind] = list;
        return list;
      });
  }
  function styleOnce() {
    if (document.getElementById('bkst-swap-style')) return;
    var s = document.createElement('style'); s.id = 'bkst-swap-style';
    s.textContent = [
      '.bkst-swap{margin:8px 0 4px;padding:10px;border:1px solid rgba(240,186,56,.45);border-radius:10px;background:rgba(240,186,56,.06);}',
      '.bkst-swap__hd{font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;opacity:.75;margin:0 0 8px;}',
      '.bkst-swap__list{display:flex;flex-direction:column;gap:6px;max-height:340px;overflow:auto;}',
      '.bkst-swap__opt{display:flex;align-items:center;gap:10px;width:100%;text-align:left;padding:7px 9px;border:1px solid rgba(128,128,128,.3);border-radius:8px;background:transparent;color:inherit;cursor:pointer;font:inherit;}',
      '.bkst-swap__opt:hover{border-color:#f0ba38;}',
      '.bkst-swap__opt.is-cur{border-color:#2ea05a;background:rgba(46,160,90,.10);}',
      '.bkst-swap__opt.is-out{opacity:.38;cursor:not-allowed;filter:grayscale(1);}',
      '.bkst-swap__opt.is-out:hover{border-color:rgba(128,128,128,.3);}',
      '.bkst-swap__opt.is-used{opacity:.5;cursor:not-allowed;}',
      '.bkst-swap__opt img{width:38px;height:38px;object-fit:cover;border-radius:6px;flex-shrink:0;background:rgba(128,128,128,.12);}',
      '.bkst-swap__nm{flex:1;min-width:0;font-size:12.5px;font-weight:700;line-height:1.25;}',
      '.bkst-swap__nm small{font-weight:500;opacity:.7;}',
      '.bkst-swap__pr{font-size:12.5px;font-weight:700;white-space:nowrap;}',
      '.bkst-swap__cur{font-size:10px;font-weight:800;letter-spacing:.06em;color:#2ea05a;text-transform:uppercase;}',
      '.bkst-swap__out{font-size:10px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;white-space:nowrap;}',
      '.bkst-swap__sep{font-size:10px;letter-spacing:.08em;text-transform:uppercase;opacity:.5;margin:6px 0 0;}',
      '.bkst-swaplink{display:inline-block;margin-top:4px;border:0;background:none;padding:0;color:#f0ba38;font:inherit;font-size:12px;font-weight:700;letter-spacing:.03em;cursor:pointer;text-decoration:underline;text-underline-offset:3px;}',
      '.bkst-swaplink:hover{filter:brightness(1.1);}'
    ].join('');
    document.head.appendChild(s);
  }
  // excludeVids: variantes já escolhidas em OUTRAS linhas do kit (não pode repetir o mesmo item).
  function buildPanel(kind, currentVid, onPick, excludeVids) {
    styleOnce();
    var used = (excludeVids || []).map(String);
    var panel = document.createElement('div'); panel.className = 'bkst-swap';
    var label = Object.prototype.hasOwnProperty.call(LABEL, kind) ? LABEL[kind] : 'Trocar';
    var hd = document.createElement('div'); hd.className = 'bkst-swap__hd'; hd.textContent = label + ' — escolha o seu';
    var wrap = document.createElement('div'); wrap.className = 'bkst-swap__list'; wrap.textContent = 'Carregando opções...';
    panel.appendChild(hd); panel.appendChild(wrap);
    fetchOptions(kind).then(function (list) {
      wrap.textContent = '';
      if (!list.length) { wrap.textContent = 'Sem opções agora.'; return; }
      var sepDone = false;
      list.forEach(function (o) {
        if (!o.available && !sepDone) {
          var sep = document.createElement('div'); sep.className = 'bkst-swap__sep'; sep.textContent = 'Esgotados no momento';
          wrap.appendChild(sep); sepDone = true;
        }
        var isCur = String(o.vid) === String(currentVid);
        var isUsed = !isCur && used.indexOf(String(o.vid)) >= 0;
        var b = document.createElement('button'); b.type = 'button';
        b.className = 'bkst-swap__opt' + (isCur ? ' is-cur' : '') + (o.available ? '' : ' is-out') + (isUsed ? ' is-used' : '');
        if (!o.available || isUsed) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
        // Nós de texto, nunca innerHTML: títulos/imagens vêm do catálogo, que pode ser alimentado por integrações.
        var im = document.createElement('img'); im.alt = ''; im.loading = 'lazy';
        if (o.img) { im.src = o.img; } else { im.hidden = true; }
        var nm = document.createElement('span'); nm.className = 'bkst-swap__nm'; nm.textContent = o.short;
        if (o.vtitle) { var sm = document.createElement('small'); sm.textContent = ' · ' + o.vtitle; nm.appendChild(sm); }
        var tag = document.createElement('span');
        if (!o.available) { tag.className = 'bkst-swap__out'; tag.textContent = 'Esgotado'; }
        else if (isCur) { tag.className = 'bkst-swap__cur'; tag.textContent = 'atual'; }
        else if (isUsed) { tag.className = 'bkst-swap__out'; tag.textContent = 'já no kit'; }
        else { tag.className = 'bkst-swap__pr'; tag.textContent = money(o.price); }
        b.appendChild(im); b.appendChild(nm); b.appendChild(tag);
        if (o.available && !isUsed) b.addEventListener('click', function () { if (!isCur) onPick(o); panel.remove(); });
        wrap.appendChild(b);
      });
    }).catch(function () {
      panel.querySelector('.bkst-swap__list').textContent = 'Não consegui carregar as opções. Tente de novo.';
    });
    return panel;
  }
  function kindOf(handle) {
    handle = String(handle || '');
    // Mesma lógica do Liquid (contains, nesta ordem).
    if (handle.indexOf('cafe') >= 0) return 'cafe';
    if (handle.indexOf('sticker') >= 0) return 'sticker';
    if (handle.indexOf('mug') >= 0 || handle.indexOf('caneca') >= 0) return 'caneca';
    if (handle.indexOf('patch') >= 0) return 'patch';
    return null;
  }
  window.BKST_SWAP = { fetchOptions: fetchOptions, buildPanel: buildPanel, money: money, shortName: shortName, kindOf: kindOf, GENERIC: GENERIC, LABEL: LABEL, styleOnce: styleOnce };
})();

/* ============================================================
 * BKST — Kit no CARRINHO: nome genérico ("1 Café Blackstone") + trocar
 * Só age em linhas adicionadas pelo kit (propriedade _bkst_kit).
 * Página /cart: nome genérico + qual é + botão trocar (troca a linha).
 * Mini-cart: só o nome genérico.
 * ============================================================ */
(function () {
  function onCartPage() { return /(^|\/)cart(\/|$|\?|#)/.test(location.pathname); }
  function cartJson() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function jsonPost(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function realLabel(it) {
    var S = window.BKST_SWAP;
    var vt = (it.variant_title && it.variant_title !== 'Default Title') ? ' · ' + it.variant_title : '';
    return S.shortName(it.product_title) + vt;
  }
  function styleOnce() {
    if (document.getElementById('bkst-cartkit-style')) return;
    var s = document.createElement('style'); s.id = 'bkst-cartkit-style';
    s.textContent = [
      '.bkst-cartkit{margin-top:3px;font-size:12.5px;line-height:1.35;}',
      '.bkst-cartkit__real{opacity:.8;}',
      '.bkst-cartkit .bkst-swaplink{margin-left:8px;margin-top:0;}'
    ].join('');
    document.head.appendChild(s);
  }
  // Troca a linha de forma segura: ADICIONA a nova primeiro e só então remove a antiga.
  // Se o add falhar (esgotou entre abrir o painel e clicar, rede, rate limit), o item original continua no carrinho.
  function findLine(c, vid, kind) {
    var idx = -1;
    c.items.forEach(function (it, i) {
      if (idx < 0 && String(it.variant_id) === String(vid) && it.properties && it.properties._bkst_kit === kind) idx = i;
    });
    return idx;
  }
  function swapLine(oldVid, kind, newVid) {
    var props = {}; props._bkst_kit = kind;
    return cartJson().then(function (c) {
      if (findLine(c, oldVid, kind) < 0) throw new Error('linha não encontrada');
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: newVid, quantity: 1, properties: props }] }) });
    }).then(function (r) {
      if (!r.ok) throw new Error('add falhou');
      return cartJson();
    }).then(function (c) {
      var idx = findLine(c, oldVid, kind);
      if (idx < 0) return c; // já não existe: nada a remover
      return jsonPost('/cart/change.js', { id: c.items[idx].key, quantity: Math.max(0, c.items[idx].quantity - 1) }); // chave da linha; tira só 1 unidade
    });
  }
  function decorateCartPage() {
    var S = window.BKST_SWAP; if (!S) return;
    styleOnce(); S.styleOnce();
    cartJson().then(function (c) {
      c.items.forEach(function (it, i) {
        var kind = it.properties && it.properties._bkst_kit; if (!kind || !Object.prototype.hasOwnProperty.call(S.GENERIC, kind)) return;
        // A mesma variante pode estar no carrinho como item de kit E como item avulso/pack (linhas separadas).
        // O tema renderiza as linhas na ordem de cart.items: pega a n-ésima linha com esse href, onde n = quantas
        // linhas anteriores do carrinho usam a mesma variante.
        var nth = 0;
        for (var j = 0; j < i; j++) { if (String(c.items[j].variant_id) === String(it.variant_id)) nth++; }
        var links = document.querySelectorAll('tr.line-item a.line-item__image-wrapper[href*="variant=' + it.variant_id + '"]');
        var imgLink = links[nth] || null;
        var row = imgLink ? imgLink.closest('tr.line-item') : null;
        if (!row || row.getAttribute('data-bkst-kit')) return;
        row.setAttribute('data-bkst-kit', kind);
        row.querySelectorAll('a.product-item-meta__title').forEach(function (a) { a.textContent = it.quantity + ' ' + S.GENERIC[kind]; });
        var host = row.querySelector('a.product-item-meta__title.hidden-phone') || row.querySelector('a.product-item-meta__title');
        if (!host) return;
        var sub = document.createElement('div'); sub.className = 'bkst-cartkit';
        var real = document.createElement('span'); real.className = 'bkst-cartkit__real'; real.textContent = realLabel(it);
        var swapBtn = document.createElement('button'); swapBtn.type = 'button'; swapBtn.className = 'bkst-swaplink'; swapBtn.textContent = S.LABEL[kind] + ' ▾';
        sub.appendChild(real); sub.appendChild(swapBtn);
        host.insertAdjacentElement('afterend', sub);
        // Esconde "Trocar" quando só existe 1 opção em estoque (ex.: caneca única).
        S.fetchOptions(kind).then(function (list) {
          var n = 0; list.forEach(function (o) { if (o.available) n++; });
          if (n <= 1) swapBtn.hidden = true;
        }).catch(function () {});
        sub.querySelector('.bkst-swaplink').addEventListener('click', function () {
          var open = row.querySelector('.bkst-swap'); if (open) { open.remove(); return; }
          var panel = S.buildPanel(kind, it.variant_id, function (o) {
            sub.querySelector('.bkst-swaplink').textContent = 'Trocando...';
            swapLine(it.variant_id, kind, o.vid)
              .then(function () { location.reload(); })
              .catch(function () { alert('Não consegui concluir a troca. Confira os itens do carrinho antes de fechar o pedido.'); location.reload(); });
          });
          sub.insertAdjacentElement('afterend', panel);
        });
      });
    }).catch(function () {});
  }
  function decorateDrawer() {
    var S = window.BKST_SWAP; if (!S) return;
    var mc = document.getElementById('mini-cart'); if (!mc) return;
    cartJson().then(function (c) {
      c.items.forEach(function (it) {
        var kind = it.properties && it.properties._bkst_kit; if (!kind || !Object.prototype.hasOwnProperty.call(S.GENERIC, kind)) return;
        mc.querySelectorAll('a[href*="variant=' + it.variant_id + '"]').forEach(function (a) {
          if (a.querySelector('img') || a.getAttribute('data-bkst-g')) return;
          a.setAttribute('data-bkst-g', '1');
          a.textContent = it.quantity + ' ' + S.GENERIC[kind];
        });
      });
    }).catch(function () {});
  }
  function run() { if (onCartPage()) decorateCartPage(); decorateDrawer(); }
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('cart:updated', function () { setTimeout(run, 80); });
  document.addEventListener('cart:refresh', function () { setTimeout(run, 80); });
  setTimeout(run, 600);
  setTimeout(run, 1800);
  (function observe() {
    var mc = document.getElementById('mini-cart');
    if (!mc) { setTimeout(observe, 700); return; }
    new MutationObserver(function () { decorateDrawer(); }).observe(mc, { childList: true, subtree: true });
  })();
})();

/* ============================================================
 * BKST — Régua do pack no CARRINHO (/cart) e no MINI-CART
 * "3 cafés = -10% aplicado. Adicione mais 1 e ganhe 15%." + botão para completar.
 * Conta só as variantes que estão na lista da família (BKST_SWAP.fetchOptions),
 * que é o MESMO conjunto dos descontos automáticos da Shopify.
 * As faixas abaixo precisam bater com os descontos cadastrados no admin
 * (e com as faixas dos blocos "Pack progressivo" no customizador).
 * ============================================================ */
(function () {
  // Desligado a pedido do Igor (23/09/2026): ofertas só na página do produto, carrinho limpo.
  var REGUA_ATIVA = false;
  if (!REGUA_ATIVA) return;
  var PACKS = {
    cafe:    { tiers: '2:15,3:20', one: 'café', many: 'cafés' },
    sticker: { tiers: '3:10,5:15,10:30', one: 'sticker', many: 'stickers' }
  };
  var KINDS = Object.keys(PACKS);
  function parseTiers(s) {
    var t = [];
    String(s || '').split(',').forEach(function (x) {
      var p = x.split(':'); var q = parseInt(p[0], 10), pc = parseInt(p[1], 10);
      if (q > 0 && pc >= 0 && pc <= 100) t.push({ qty: q, pct: pc });
    });
    t.sort(function (a, b) { return a.qty - b.qty; });
    return t;
  }
  KINDS.forEach(function (k) { PACKS[k].list = parseTiers(PACKS[k].tiers); });
  function pctFor(tiers, n) { var p = 0; tiers.forEach(function (t) { if (n >= t.qty && t.pct > p) p = t.pct; }); return p; }
  function nextTier(tiers, n) { for (var i = 0; i < tiers.length; i++) { if (n < tiers[i].qty) return tiers[i]; } return null; }
  function money(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function onCartPage() { return /(^|\/)cart(\/|$|\?|#)/.test(location.pathname); }
  function cartJson() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }); }

  function styleOnce() {
    if (document.getElementById('bkst-packbar-style')) return;
    var s = document.createElement('style'); s.id = 'bkst-packbar-style';
    s.textContent = [
      '.bkst-packbars{margin:12px 0;}',
      '.bkst-packbar{margin:0 0 10px;padding:12px 14px;border:1px solid rgba(240,186,56,.55);border-radius:10px;background:rgba(240,186,56,.06);}',
      '.bkst-packbar.is-max{border-color:rgba(94,224,138,.7);background:rgba(46,160,90,.08);box-shadow:0 0 10px rgba(94,224,138,.25);}',
      '.bkst-packbar__t{display:flex;align-items:baseline;flex-wrap:wrap;gap:6px 10px;font-size:13.5px;font-weight:800;letter-spacing:.02em;}',
      '.bkst-packbar__pct{color:#f0ba38;}',
      '.bkst-packbar.is-max .bkst-packbar__pct{color:#7dffa8;text-shadow:0 0 8px rgba(94,224,138,.8);}',
      '.bkst-packbar__saved{font-size:12.5px;font-weight:600;opacity:.8;}',
      '.bkst-packbar__next{margin-top:4px;font-size:12.5px;font-weight:700;color:#f0ba38;}',
      '.bkst-packbar.is-max .bkst-packbar__next{color:#7dffa8;text-shadow:0 0 8px rgba(94,224,138,.8);}',
      '.bkst-packbar__bar{display:block;height:7px;border-radius:6px;background:rgba(128,128,128,.25);margin-top:9px;overflow:hidden;}',
      '.bkst-packbar__fill{display:block;height:100%;border-radius:6px;background:#f0ba38;transition:width .4s;}',
      '.bkst-packbar.is-max .bkst-packbar__fill{background:#5ee08a;box-shadow:0 0 8px rgba(94,224,138,.9);}',
      '.bkst-packbar__btn{display:inline-block;margin-top:10px;border:1px solid #f0ba38;border-radius:6px;background:transparent;color:#f0ba38;padding:8px 12px;font:inherit;font-size:12px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;}',
      '.bkst-packbar__btn:hover{background:#f0ba38;color:#1a1712;}',
      '.bkst-packbar__btn[disabled]{opacity:.5;cursor:default;}',
      '.bkst-packbar .bkst-swap{margin-top:8px;}'
    ].join('');
    document.head.appendChild(s);
  }

  // kind -> { variantId: true } (mesmo conjunto do escopo do desconto)
  var sets = Object.create(null);
  function loadSets() {
    var S = window.BKST_SWAP; if (!S) return Promise.reject(new Error('sem módulo'));
    // Cada família falha sozinha: se uma coleção sumir, a outra régua continua.
    return Promise.all(KINDS.map(function (k) {
      if (sets[k]) return null;
      return S.fetchOptions(k).then(function (list) {
        var set = Object.create(null);
        list.forEach(function (o) { set[String(o.vid)] = true; });
        sets[k] = set;
      }).catch(function () {});
    }));
  }
  function stats(c, kind) {
    var n = 0, disc = 0, orig = 0, set = sets[kind];
    if (!set) return { n: 0, disc: 0, orig: 0 };
    c.items.forEach(function (it) {
      if (set[String(it.variant_id)]) {
        n += it.quantity;
        disc += (typeof it.total_discount === 'number' ? it.total_discount : 0);
        orig += (typeof it.original_line_price === 'number' ? it.original_line_price : 0);
      }
    });
    return { n: n, disc: disc, orig: orig };
  }

  function addOne(vid) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().then(function (e) { throw new Error((e && (e.description || e.message)) || ('add ' + r.status)); },
                           function () { throw new Error('add ' + r.status); });
    });
  }
  function afterAdd() {
    if (onCartPage()) { location.reload(); return; }
    // Mini-cart: pede ao tema para re-renderizar e atualiza a régua.
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    setTimeout(run, 900);
  }

  // Nós de texto, nunca innerHTML (títulos vêm do catálogo).
  function buildBar(kind, st) {
    var P = PACKS[kind], tiers = P.list, S = window.BKST_SWAP;
    if (!tiers.length) return null;
    var nx = nextTier(tiers, st.n), max = tiers[tiers.length - 1];
    // "% aplicado" sai do desconto REAL que a Shopify colocou nas linhas (nunca da faixa prometida):
    // se um cupom derrubar o automático, a régua mostra o que existe de verdade.
    var realPct = (st.disc > 0 && st.orig > 0) ? Math.round(st.disc * 100 / st.orig) : 0;
    var bar = document.createElement('div'); bar.className = 'bkst-packbar' + (nx ? '' : ' is-max'); bar.setAttribute('data-kind', kind);
    var t = document.createElement('div'); t.className = 'bkst-packbar__t';
    var n = document.createElement('span'); n.textContent = st.n + ' ' + (st.n === 1 ? P.one : P.many) + ' no carrinho';
    t.appendChild(n);
    if (realPct > 0) {
      var pe = document.createElement('span'); pe.className = 'bkst-packbar__pct'; pe.textContent = '-' + realPct + '% aplicado';
      t.appendChild(pe);
      var sv = document.createElement('span'); sv.className = 'bkst-packbar__saved'; sv.textContent = '(você economiza ' + money(st.disc) + ')'; t.appendChild(sv);
    }
    bar.appendChild(t);
    var nxEl = document.createElement('div'); nxEl.className = 'bkst-packbar__next';
    nxEl.textContent = nx
      ? ('Adicione mais ' + (nx.qty - st.n) + ' ' + ((nx.qty - st.n) === 1 ? P.one : P.many) + ' e ganhe ' + nx.pct + '% de desconto.')
      : ('Desconto máximo de ' + max.pct + '% atingido.');
    bar.appendChild(nxEl);
    var track = document.createElement('span'); track.className = 'bkst-packbar__bar';
    var fill = document.createElement('span'); fill.className = 'bkst-packbar__fill';
    fill.style.width = Math.max(4, Math.min(100, Math.round(st.n * 100 / max.qty))) + '%';
    track.appendChild(fill); bar.appendChild(track);
    if (nx && S) {
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'bkst-packbar__btn';
      btn.textContent = 'Adicionar mais 1 ' + P.one + ' ▾';
      btn.addEventListener('click', function () {
        var open = bar.querySelector('.bkst-swap'); if (open) { open.remove(); return; }
        var panel = S.buildPanel(kind, null, function (o) {
          btn.disabled = true; btn.textContent = 'Adicionando...';
          addOne(o.vid).then(afterAdd).catch(function (err) {
            btn.disabled = false; btn.textContent = 'Adicionar mais 1 ' + P.one + ' ▾';
            var msg = (err && err.message && !/^add \d+$/.test(err.message)) ? err.message : 'Não consegui adicionar agora. Tente novamente.';
            alert(msg);
          });
        }, []);
        bar.appendChild(panel);
      });
      bar.appendChild(btn);
    }
    return bar;
  }

  function renderInto(target, c) {
    var box = target.querySelector(':scope > .bkst-packbars');
    // Painel de escolha aberto: não re-renderiza por baixo do cliente (evita clique no item errado).
    if (box && box.querySelector('.bkst-swap')) return;
    var bars = [];
    KINDS.forEach(function (k) { var st = stats(c, k); if (st.n > 0) { var b = buildBar(k, st); if (b) bars.push(b); } });
    if (!bars.length) { if (box) box.remove(); return; }
    if (!box) { box = document.createElement('div'); box.className = 'bkst-packbars'; }
    // Fica logo abaixo da caixa de frete quando ela existe; senão, no topo.
    var frete = target.querySelector(':scope > .bkst-frete');
    if (frete) { if (frete.nextElementSibling !== box) frete.insertAdjacentElement('afterend', box); }
    else if (target.firstElementChild !== box) { target.insertBefore(box, target.firstChild); }
    box.textContent = '';
    bars.forEach(function (b) { box.appendChild(b); });
  }

  var busy = false, again = null;
  function run() {
    // Já tem uma leitura em andamento: reagenda em vez de perder o gatilho.
    if (busy) { clearTimeout(again); again = setTimeout(run, 400); return; }
    var pageTarget = null, drawerTarget = document.querySelector('#mini-cart .mini-cart__drawer-footer');
    if (onCartPage()) {
      pageTarget = document.querySelector('.cart .cart__content') || document.querySelector('.cart__content') || document.querySelector('.cart');
    }
    if (!pageTarget && !drawerTarget) return;
    busy = true;
    loadSets().then(cartJson).then(function (c) {
      styleOnce();
      if (pageTarget) renderInto(pageTarget, c);
      if (drawerTarget) renderInto(drawerTarget, c);
    }).catch(function () {}).then(function () { busy = false; });
  }
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('cart:updated', function () { setTimeout(run, 120); });
  document.addEventListener('cart:refresh', function () { setTimeout(run, 120); });
  setTimeout(run, 700);
  setTimeout(run, 2000);
  (function observe() {
    var mc = document.getElementById('mini-cart');
    if (!mc) { setTimeout(observe, 700); return; }
    var timer = null;
    new MutationObserver(function (muts) {
      // Ignora as mutações que nós mesmos causamos (senão vira loop).
      var ours = true;
      for (var i = 0; i < muts.length; i++) { var tg = muts[i].target; if (!(tg && tg.closest && tg.closest('.bkst-packbars'))) { ours = false; break; } }
      if (ours) return;
      clearTimeout(timer); timer = setTimeout(run, 200);
    }).observe(mc, { childList: true, subtree: true });
  })();
})();

/* ============================================================
 * BKST — Carrinho limpo (23/09/2026, pedido do Igor)
 * Esconde o "Você também pode gostar" do mini-cart. Ofertas ficam
 * só na página do produto (kit e pack continuam lá).
 * ============================================================ */
(function () {
  if (document.getElementById('bkst-cart-clean')) return;
  var s = document.createElement('style');
  s.id = 'bkst-cart-clean';
  s.textContent = '#mini-cart .mini-cart__recommendations{display:none!important;}';
  (document.head || document.documentElement).appendChild(s);
})();

/* ============================================================
 * BKST — Link de carrinho pronto (23/09/2026)
 * Uso: blackstonebrasil.com.br/cart?carrinho=SKU:QTD,SKU:QTD
 *      (aceita também o id numérico da variante no lugar do SKU)
 * Monta o carrinho e dispara o checkout pelo mesmo gatilho do tema,
 * então passa pela Bestfy (o link nativo /cart/ID:QTD pula a Bestfy).
 * Item inexistente ou esgotado: NÃO segue; mostra o problema e manda
 * o cliente para o carrinho montado com o que deu certo.
 * ============================================================ */
(function () {
  var params;
  try { params = new URLSearchParams(location.search); } catch (e) { return; }
  var raw = params.get('carrinho');
  if (!raw) return;

  // Tira o parâmetro da URL já: se o cliente voltar do checkout, não remonta nem redireciona de novo.
  try {
    params.delete('carrinho');
    var qs = params.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  } catch (e) {}

  var MAX_LINHAS = 20, MAX_QTD = 20;
  var pedidos = [];
  String(raw).split(',').slice(0, MAX_LINHAS).forEach(function (par) {
    var p = par.split(':');
    var cod = String(p[0] || '').trim().toUpperCase().replace(/[^A-Z0-9_-]/g, '');
    var qtd = parseInt(p[1] || '1', 10);
    if (!cod) return;
    if (!(qtd >= 1)) qtd = 1;
    if (qtd > MAX_QTD) qtd = MAX_QTD;
    pedidos.push({ cod: cod, qtd: qtd });
  });
  if (!pedidos.length) return;

  function overlay() {
    var o = document.getElementById('bkst-carrinho-pronto');
    if (o) return o;
    o = document.createElement('div');
    o.id = 'bkst-carrinho-pronto';
    o.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(17,17,17,.94);color:#F5F5F5;display:flex;align-items:center;justify-content:center;padding:24px;font:600 16px/1.45 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;text-align:center;';
    var box = document.createElement('div');
    box.style.cssText = 'max-width:420px;';
    var t = document.createElement('div'); t.className = 'bkst-cp-t';
    t.style.cssText = 'font-size:18px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#F0BA38;margin-bottom:10px;';
    var m = document.createElement('div'); m.className = 'bkst-cp-m';
    box.appendChild(t); box.appendChild(m); o.appendChild(box);
    (document.body || document.documentElement).appendChild(o);
    return o;
  }
  function msg(titulo, texto, botao) {
    var o = overlay();
    o.querySelector('.bkst-cp-t').textContent = titulo;
    var m = o.querySelector('.bkst-cp-m'); m.textContent = texto;
    if (botao) {
      var a = document.createElement('a');
      a.href = '/cart'; a.textContent = botao;
      a.style.cssText = 'display:inline-block;margin-top:16px;padding:12px 20px;border-radius:4px;background:#F0BA38;color:#111;font-weight:800;text-decoration:none;text-transform:uppercase;letter-spacing:.05em;';
      m.appendChild(document.createElement('br')); m.appendChild(a);
    }
  }

  function catalogo() {
    var mapa = Object.create(null), pagina = 1;
    function lote() {
      return fetch('/products.json?limit=250&page=' + pagina, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('catalogo ' + r.status); return r.json(); })
        .then(function (d) {
          var ps = (d && d.products) || [];
          ps.forEach(function (p) {
            (p.variants || []).forEach(function (v) {
              var info = { id: v.id, ok: !!v.available, nome: p.title + (v.title && v.title !== 'Default Title' ? ' ' + v.title : '') };
              if (v.sku) mapa[String(v.sku).toUpperCase()] = info;
              mapa[String(v.id)] = info;
            });
          });
          if (ps.length === 250 && pagina < 8) { pagina++; return lote(); }
          return mapa;
        });
    }
    return lote();
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || (url + ' ' + r.status));
        return j;
      });
    });
  }

  // Dispara o checkout pelo mesmo caminho de um clique em "Finalizar compra":
  // o script da Bestfy intercepta botões name="checkout" e leva ao checkout dela.
  function irParaCheckout() {
    var b = document.createElement('button');
    b.type = 'button'; b.name = 'checkout'; b.style.display = 'none';
    document.body.appendChild(b);
    b.click();
    // Se nada interceptar em 8 s, segue pelo caminho padrão da loja.
    setTimeout(function () { location.href = '/checkout'; }, 8000);
  }

  function quandoPronto(fn) {
    if (document.readyState === 'complete') { setTimeout(fn, 300); return; }
    window.addEventListener('load', function () { setTimeout(fn, 300); });
  }

  function iniciar() {
    msg('Montando seu carrinho', 'Só um instante...');
    catalogo().then(function (mapa) {
      var itens = [], problemas = [];
      pedidos.forEach(function (p) {
        var v = mapa[p.cod];
        if (!v) { problemas.push('Não encontramos o item ' + p.cod + '.'); return; }
        if (!v.ok) { problemas.push(v.nome + ' está esgotado.'); return; }
        itens.push({ id: v.id, quantity: p.qtd });
      });
      return postJson('/cart/clear.js', {}).then(function () {
        if (!itens.length) return null;
        return postJson('/cart/add.js', { items: itens }).catch(function () {
          // Lote recusado (ex.: quantidade acima do estoque): tenta um por um e guarda o motivo de cada falha.
          return itens.reduce(function (cadeia, it) {
            return cadeia.then(function () {
              return postJson('/cart/add.js', { items: [it] }).catch(function (err) {
                problemas.push(String(err && err.message || 'Um item não pôde ser adicionado.'));
              });
            });
          }, Promise.resolve());
        });
      }).then(function () {
        if (problemas.length) {
          msg('Confira seu carrinho', problemas.join(' '), 'Ver carrinho');
          return;
        }
        msg('Carrinho pronto', 'Levando você para o pagamento seguro...');
        quandoPronto(irParaCheckout);
      });
    }).catch(function () {
      msg('Não deu para montar o carrinho', 'Tente abrir o link de novo ou fale com a gente no WhatsApp.', 'Ver carrinho');
    });
  }

  if (document.body) iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);
})();
